import { useConfig } from "./ConfigProvider";

const Footer = () => {
  const config = useConfig();

  const footerStyle = config.htmlCustomCSS
    ? {}
    : {
        backgroundColor: "#000",
        padding: "0rem 1rem 1rem 1rem",
        color: "#ffffff",
        textAlign: "center",
      };

  const spanStyle = config.htmlCustomCSS
    ? {}
    : {
        marginTop: "0.2rem",
        marginBottom: "-.5rem",
        fontSize: "0.7rem",
        textAlign: "center",
      };

  const cgvStyle = config.htmlCustomCSS
    ? {}
    : {
        marginTop: "1rem",
        textDecoration: "underline",
      };

  return (
    <footer style={footerStyle}>
      {config.footer.logo && (
        <img src={config.footer.logo} alt={config.companyName} style={{ width: "10rem", margin: "0.5rem auto" }} />
      )}
      {config.footer.textLine && <p>{config.footer.textLine}</p>}
      <span style={spanStyle}>
        {new Date().getFullYear()} &copy; {config.companyName}
      </span>
      {config.footer.cgv && (
        <span style={cgvStyle}>
          <a target="_blank" href={config.footer.cgv.link} rel="noreferrer">
            {config.footer.cgv.text}
          </a>
        </span>
      )}
    </footer>
  );
};

export default Footer;
